import React from "react";
import Button from "@material-ui/core/Button";
import propTypes from "prop-types";

// bouton de base a utiliser comme reference dans le projet

const BaseButton = ({ disabled, label, onClick, ...otherProps }) => (
  <Button disabled={disabled} onClick={onClick} {...otherProps}>
    {label}
  </Button>
);

BaseButton.propTypes = {
  label: propTypes.string.isRequired,
  disabled: propTypes.bool,
  onClick: propTypes.func
};

BaseButton.defaultProps = {
  variant: "contained",
  color: "primary",
  disabled: false,
  onClick: () => {}
};

export default BaseButton;
